import React from 'react';

import { InProgressOverview } from 'features/deals/InProgress';

const AllTradesTab = () => {
  return (
    <div className="p-4 text-center text-lg text-slate-300">
      <InProgressOverview />
    </div>
  );
};

export default AllTradesTab;
